module.exports = __webpack_public_path__ + "img/dante-poster-2.9ffc99dc.jpg";